module.exports = __webpack_public_path__ + "static/media/mobPhone.8c2ddde2.svg";